// src/services/productService.js

const BASE_URL = process.env.REACT_APP_API_URL;

// ============================
// GET ALL PRODUCTS
// ============================
export const fetchProducts = async ({
  page = 1,
  limit = 12,
  search = "",
  category = "",
  sort = "",
  minPrice = "",
  maxPrice = "",
  inStock = "",
  badge = "",
} = {}) => {

  try {

    const params = new URLSearchParams();

    params.append("page", page);
    params.append("limit", limit);

    if (search) params.append("search", search);
    if (category && category !== "All") {
      params.append("category", category);
    }

    if (sort && sort !== "default") {
      params.append("sort", sort);
    }

    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);

    if (inStock) params.append("inStock", inStock);

    if (badge) params.append("badge", badge);

    const res = await fetch(
      `${BASE_URL}/products?${params.toString()}`
    );

    const result = await res.json();
    console.log("All Products:", result.data);
    return result.data;

  } catch (error) {

    console.error("Fetch products error:", error);

    return {
      products: [],
    };
  }
};

// ============================
// GET CATEGORIES
// ============================
export const fetchCategories = async () => {

  try {

    const res = await fetch(
      `${BASE_URL}/products/categories`
    );

    const result = await res.json();

    console.log(
      "CATEGORY API RESPONSE:",
      result
    );

    // IMPORTANT FIX

    return Array.isArray(result?.data)
      ? result.data
      : [];

  } catch (error) {

    console.error(
      "Fetch categories error:",
      error
    );

    return [];
  }
};

// ============================
// GET SINGLE PRODUCT
// ============================
export const fetchSingleProduct = async (id) => {

  try {

    const res = await fetch(
      `${BASE_URL}/products/${id}`
    );

    const result = await res.json();

    return result.data;

  } catch (error) {

    console.error("Fetch product error:", error);

    return null;
  }
};